import 'components/select';
import NestedSelects from 'utils/nested_selects';

export default class DisciplinesSubjectsSelect {
  static subjectOptionRenderer(
    { option, defaultHtml },
    enableVisualTree = false
  ) {
    if (option.isHeading) {
      return `<li tabindex="0" class="q-select-heading" >${option.name}</li>`;
    } else if (enableVisualTree) {
      const padding = option.level * 15;
      return defaultHtml.replace(
        '<li ',
        `<li data-parent="${
          option.level === 1 ? 'true' : 'false'
        }" style="padding-left: ${padding}px;" `
      );
    } else {
      return defaultHtml;
    }
  }

  static formatNestedSubjects(
    prevIndexes,
    subjects,
    hideNestedSubjects = false
  ) {
    subjects = subjects.sort((a, b) => a.sort - b.sort);

    return subjects.reduce((res, subject, i) => {
      const indexes = [...prevIndexes, i + 1];

      res.push({
        id: subject.id,
        name: `${indexes.join('.')} ${subject.name}`,
        level: indexes.length
      });

      if (
        !hideNestedSubjects &&
        subject.nested_subjects &&
        subject.nested_subjects.length
      ) {
        res = res.concat(
          this.formatNestedSubjects(indexes, subject.nested_subjects)
        );
      }

      return res;
    }, []);
  }

  static subjectFormatter($disciplineSelect, data, hideNestedSubjects = false) {
    const disciplines = $disciplineSelect.get(0).qselectInstance.options;
    return Object.keys(data).reduce((result, key) => {
      const discipline = disciplines.find(
        d => d.id.toString() === key.toString()
      );

      if (!discipline) {
        return result;
      }

      result.push({
        isHeading: true,
        name: discipline.nome
      });

      const subjects = this.formatNestedSubjects(
        [],
        data[key],
        hideNestedSubjects
      );
      return result.concat(subjects);
    }, []);
  }

  static init(
    $disciplineSelect,
    $subjectSelect,
    options = {
      enableVisualTree: false,
      hideNestedSubjects: false
    }
  ) {
    $disciplineSelect.qselect();
    const selectedDiscipline = $disciplineSelect.get(0).dataset.value;

    if (selectedDiscipline) {
      $disciplineSelect.qselect('setValue', selectedDiscipline);
    }

    $subjectSelect
      .qselect()
      .qselect('disable')
      .qselect('setOptionRenderingFunction', data =>
        this.subjectOptionRenderer(data, options.enableVisualTree)
      )
      .qselect('setFormatFunction', data =>
        this.subjectFormatter(
          $disciplineSelect,
          data,
          options.hideNestedSubjects
        )
      );

    NestedSelects.init($disciplineSelect, $subjectSelect, 'discipline_ids');
  }
}
